require('./bootstrap');


window.moment = require('moment');
window.validate = require('jquery-validation');

$.validator.addMethod("zipCode", function (value, element) {
    return this.optional(element) || /^[a-zA-Z0-9]*$/.test(value);
}, "Please enter a valid code");

jQuery.validator.addMethod("phoneRule", function (phone_number, element) {
    phone_number = phone_number.replace(/\s+/g, "");
    return this.optional(element) || phone_number.length > 9 &&
        phone_number.match(/^(\+?1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
}, "Please enter a valid number");

jQuery.validator.addMethod("alphanumeric", function (value, element) {
    return this.optional(element) || /^[a-zA-Z0-9_ -]*$/.test(value);
}, "Please enter a valid string");

window.Swal = require('sweetalert2');
require('../../node_modules/jquery-tags-input/dist/jquery.tagsinput.min.js');
window.datetimepicker = require('daterangepicker');
require( 'datatables.net-bs5' );
require('./site-assets/slider.js');
require('./custom.js');
require('./site-assets/users.js');
require('./site-assets/strongbox.js');
require('./site-assets/settings.js');
require('./site-assets/groups.js');
require('./site-assets/reports.js');
require('./site-assets/payment.js');
require('./site-assets/billing.js');
require('./site-assets/sites.js');
require('./site-assets/vm_import.js');
